/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  CreateIdentityVerificationErrorResponse,
  CreateIdentityVerificationRequest,
  CreateIdentityVerificationResponse,
} from './api.schemas';

import { api } from '../util/http';

export const createEncountersIdentityVerification = (
  encounterId: number,
  createIdentityVerificationRequest: CreateIdentityVerificationRequest,
  signal?: AbortSignal,
) => {
  return api<CreateIdentityVerificationResponse>({
    url: `/api/encounters/${encounterId}/identity-verification`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createIdentityVerificationRequest,
    signal,
  });
};

export const getCreateEncountersIdentityVerificationMutationOptions = <
  TError = CreateIdentityVerificationErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEncountersIdentityVerification>>,
    TError,
    { encounterId: number; data: CreateIdentityVerificationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEncountersIdentityVerification>>,
  TError,
  { encounterId: number; data: CreateIdentityVerificationRequest },
  TContext
> => {
  const mutationKey = ['createEncountersIdentityVerification'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEncountersIdentityVerification>>,
    { encounterId: number; data: CreateIdentityVerificationRequest }
  > = (props) => {
    const { encounterId, data } = props ?? {};

    return createEncountersIdentityVerification(encounterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEncountersIdentityVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEncountersIdentityVerification>>
>;
export type CreateEncountersIdentityVerificationMutationBody = CreateIdentityVerificationRequest;
export type CreateEncountersIdentityVerificationMutationError =
  CreateIdentityVerificationErrorResponse;

export const useCreateEncountersIdentityVerification = <
  TError = CreateIdentityVerificationErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEncountersIdentityVerification>>,
      TError,
      { encounterId: number; data: CreateIdentityVerificationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEncountersIdentityVerification>>,
  TError,
  { encounterId: number; data: CreateIdentityVerificationRequest },
  TContext
> => {
  const mutationOptions = getCreateEncountersIdentityVerificationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
